import Button from '../../components/base/Button';
import Seo from '../../components/feature/Seo';
import { areaClusters, PHONE_HREF, WHATSAPP_HREF } from '../../lib/schiek-content';

export default function EinsatzgebietePage() {
  return (
    <main className="bg-white pt-28 pb-20">
      <Seo
        title="Einsatzgebiete Berlin | Abschleppdienst Schiek"
        description="Abschleppdienst Schiek ist in Berlin und Umgebung im Einsatz: Pannenhilfe, Unfallbergung, Falschparker und Fahrzeugtransport."
        path="/einsatzgebiete"
      />

      <section className="px-5" aria-labelledby="areas-heading">
        <div className="mx-auto max-w-6xl rounded-[2rem] border border-slate-200 bg-slate-50 p-6 md:p-10">
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.24em] text-[#0F3D8C]">
            Einsatzgebiete
          </p>
          <h1 id="areas-heading" className="max-w-4xl text-3xl font-semibold leading-tight text-slate-950 sm:text-5xl">
            Abschleppdienst in Berlin und Umgebung
          </h1>
          <p className="mt-5 max-w-3xl text-base leading-relaxed text-slate-700 sm:text-lg">
            Schiek hilft bei Panne, Unfall, Falschparkern und Fahrzeugtransporten in Berlin. Wenn Sie unsicher sind,
            ob Ihr Standort abgedeckt ist, rufen Sie kurz an. Wir sagen direkt, welche Hilfe möglich ist und welches Zeitfenster realistisch wirkt.
          </p>
          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <Button href={PHONE_HREF} size="lg" className="whitespace-normal px-6 text-sm">
              Standort telefonisch klären
            </Button>
            <Button href={WHATSAPP_HREF} variant="secondary" size="lg" className="whitespace-normal px-6 text-sm">
              Standort per WhatsApp senden
            </Button>
          </div>
        </div>
      </section>

      <section className="px-5 py-16" aria-labelledby="areas-list-heading">
        <div className="mx-auto max-w-6xl">
          <h2 id="areas-list-heading" className="text-2xl font-semibold text-slate-950 sm:text-3xl">
            Bezirke und Einsatzräume
          </h2>
          <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {areaClusters.map((area) => (
              <article key={area} className="rounded-3xl border border-slate-200 bg-white p-5 shadow-[0_14px_36px_rgba(15,23,42,0.05)]">
                <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#0F3D8C]">Berlin</p>
                <h3 className="mt-2 text-lg font-semibold text-slate-950">{area}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-700">
                  Einsätze nach Verfügbarkeit, Verkehrslage und konkretem Standort. Am Telefon erhalten Sie eine
                  realistische Einschätzung.
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
